import { Card } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import SemiCircleChartSkeleton from '@/app/common/components/skeleton/SemiCircleChartSkeleton';
import type { CSSProperties, ReactNode } from 'react';

type CardChartSemiCircleLoadingProps = {
  title?: ReactNode;
  tooltip?: ReactNode;
  minHeight?: CSSProperties['minHeight'];
  styles?: CSSProperties;
};

const CardChartSemiCircleLoading = ({
  title,
  tooltip
}: CardChartSemiCircleLoadingProps) => {
  return (
    <Card>
      <FalconCardHeader
        title={
          <div>
            {title}
            <HelpTooltip html={tooltip} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
      />
      <Card.Body className="px-0">
        <SemiCircleChartSkeleton
          styles={{
            borderRadius: '12rem 12rem 0 0',
            width: '60%',
            height: '150px',
            margin: '32px 0 32px 0'
          }}
        />
      </Card.Body>
    </Card>
  );
};

export default CardChartSemiCircleLoading;
